import { IApplicationState } from '../../types/redux';

export const selectSlideIndex = (state: IApplicationState): number => {
  return state.fullscreenGallery.slideIndex || 0;
};
